import { useHistory, useLocation } from '@react-router';
import { useTranslation } from '@shared/core';
import { useEventNameMatch } from '@shared/components/AuthProvider/AuthProvider.utils';
import type { SuccessFormProps } from './FindInviteSuccessForm';

export const useFindInviteSuccessController = ({ guest, onDialogClose }: SuccessFormProps) => {
  const history = useHistory();
  const location = useLocation();
  const { eventName } = useEventNameMatch();
  const { t, t2 } = useTranslation('guestUnlock');
  const title = t('findInviteSuccessForm', 'title')({ firstName: guest.firstName });
  const { subtitle, submitButtonText } = t2('findInviteSuccessForm');

  const onSubmitHandler = () => {
    onDialogClose();
    history.push(`/${eventName}/schedule${location.search}`);
  };

  return {
    title,
    subtitle,
    submitButtonText,
    onSubmitHandler,
  };
};
